import { useWallet, WalletStatus } from "@terra-money/wallet-provider";
import TxModal from "components/Modal/TxModal";
import { bankSend, sendToIndexFund } from "components/Msgs/Msgs";
import WalletInstructionModal from "components/Modal/WalletInstructionModal";
import { toChainAmount, toTerraAmount } from "functions/toXAmount";
import useAddress from "hooks/useAddress";
import { useState } from "react";
import { useBalance, useChainAddress } from "state/global";
import { uMap } from "constants/constants";
import st_dn from "./DonateNow.module.css";
import { Coin } from "@terra-money/terra.js";
import DonationInfo from "./DonationInfo";
import ConnectButton from "components/WalletProvider/ConnectButton";
import ConnectModal from "components/WalletProvider/ConnectModal";

const currencyStyle = {
    fontWeight: '500',
    border: '2px solid #0057b7',
    borderRadius: "10px",
    padding: '10px 30px',
    cursor: 'pointer',
    color: '#0057b7'
}

const clickedCurrencyStyle = {
    fontWeight: '500',
    border: '2px solid #0057b7',
    borderRadius: "10px",
    padding: '10px 30px',
    backgroundColor: '#0057b7',
    color: 'white',
    cursor: 'pointer',
}

enum Currency {
    LUNA = "uluna",
    UST = "uusd",
    ETH = "eth",
    BNB = "bnb",
}

const DonateNow = (): JSX.Element => {
    const { connect, status } = useWallet();
    const user_address = useAddress();
    const [eth_address] = useChainAddress("address");

    const [open, setOpen] = useState<boolean>(false);
    const [connectOpen, setConnectOpen] = useState<boolean>(false);
    const [currency, setCurrency] = useState<Partial<Currency>>(Currency.LUNA);
    const [relAmount] = useBalance(currency);
    const [amount, setAmount] = useState<number>(0);
    const [msgs, setMsgs] = useState<any>([]);

    const setInputAmount = (number: number) => {
        if( !(Math.round( number * 1000 ) / 1000 != number) ) {
            setAmount(toChainAmount(number));
        }
    }

    const donate = () => {
        if (status !== WalletStatus.WALLET_CONNECTED && eth_address === "") {
            connect();
            return;
        } else if (amount === 0) {
            alert("Please input a number greater than 0.001");
            return;
        } else if (relAmount < amount) {
            alert("Not enough balance");
            return;
        }

        const msgs = currency === "eth" || currency === "bnb" ? [amount] : currency === "uusd" ? 
        sendToIndexFund(user_address, + process.env.REACT_APP_FUND_ID!, [new Coin(currency, amount)]) : 
        bankSend(user_address, { [currency]: amount });

        setMsgs(msgs);
    }

    const donateOrConnect = () => {
        status === WalletStatus.WALLET_CONNECTED || eth_address !== "" ?
        donate() : setConnectOpen(true);
    }

    const CurrencyButton = ({ repCurr }: { repCurr: Partial<Currency> }): JSX.Element => {
        return (
            <button onClick={() => setCurrency(repCurr)}
            style={currency === repCurr ? clickedCurrencyStyle : currencyStyle}
            >{uMap.get(repCurr)}</button>
        )
    }

    return (
      <>
        <WalletInstructionModal open={open} setOpen={setOpen} />
        <TxModal msgs={msgs} denom={currency} amount={amount} />
        <ConnectModal open={connectOpen} setOpen={setConnectOpen} />
        <section className={st_dn.section} id="donate_now">
          <div className={st_dn.inner_container}>
            <h1 className={st_dn.big_title}>
              Donate now to save refugees in need
            </h1>
            <p className={st_dn.intro_paragraph}>
              100% of your donations will go directly to Ukrainian humanitarian
              relief efforts. Half will be used for immediate impact, and half
              will be invested in perpetual endowments to provide ongoing
              relief, forever.
            </p>
            <div className={st_dn.main_container}>
              <div className={st_dn.image_container} />
              <div className={st_dn.right}>
                <p className={st_dn.supported_wallets}>
                  Supported Wallets: Terra Station, MetaMask, Binance Wallet,
                  xDefi, Leap
                  <br />
                  <span onClick={() => setOpen(true)}>Wallet Instructions</span>
                </p>
                <h4 className={st_dn.currency_title}>Currency</h4>
                <div className={st_dn.currency_container}>
                  <CurrencyButton repCurr={Currency.LUNA} />
                  <CurrencyButton repCurr={Currency.UST} />
                  <CurrencyButton repCurr={Currency.ETH} />
                  <CurrencyButton repCurr={Currency.BNB} />
                </div>
                <h4 className={st_dn.amount_title}>
                  Amount
                  <span>
                    Wallet Balance: {toTerraAmount(relAmount).toFixed(3)}
                  </span>
                </h4>
                <input
                  type="number"
                  step=".01"
                  placeholder="0.00"
                  onChange={(e) => setInputAmount(+e.target.value)}
                  value={amount === 0 ? undefined : toTerraAmount(amount)}
                  className={st_dn.input}
                />
                <br />
                <button
                  className={st_dn.donate_button}
                  onClick={() => donateOrConnect()}
                >
                  {status === WalletStatus.WALLET_CONNECTED ||
                  eth_address !== ""
                    ? "Donate Now"
                    : "Connect Wallet"}
                </button>
              </div>
            </div>
          </div>
          <h1 className={st_dn.disclaimer}>
            * This will split donations across partner orgs. If you prefer to
            donate to a specific charity and set your own split between
            immediate/endowment funding, please click into an individual charity
            below
          </h1>
        </section>
        <DonationInfo />
      </>
    );
}

export default DonateNow;
